import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BsPlusCircleFill } from 'react-icons/bs';
import { CiEdit } from 'react-icons/ci';
import { RiDeleteBin5Line, RiGalleryUploadLine } from 'react-icons/ri';


interface slider{
  id:number,
  image:string,
}

const Gallery = () => {
  const api = process.env.REACT_APP_API_URL as string;
    const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
    const[sliderdata, setSliderdata] = useState<slider[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
  
    // Open modal
    const openModal = (postId: string) => {
      setSelectedPostId(postId);
      setIsModalOpen(true);
    };
  
    // Function to close modal and clear the post ID
    const closeModal = () => {
      setSelectedPostId(null);
      setIsModalOpen(false);
    };
  
    const deletePost = async (id: any) => {
      if (!id) {
        alert('Invalid ID. Cannot delete.');
        return;
      }
      const confirmation = window.confirm('Are you sure you want to delete this image?');
      if(!confirmation){
        return;
      }
    
      try {
        // Make the DELETE request
        await axios.delete(`${api}/auth/gallery/${id}`);
        alert('image deleted successfully!');
        window.location.reload();
      } catch (error) {
        console.error('Error deleting image:', error);
        alert('Failed to delete the image. Please try again later.');
      }
    };
    
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<slider[]>(
            `${api}/auth/gallery`
          );
  
          //console.log('gallery data',response.data)
          setSliderdata(response.data);
          //console.log("gallery data in a array",sliderdata);
        } catch (error) {
          console.error("gallery Not Found:", error);
        }
      };
  
      fetchData();
    }, []);

  return (
    <div className='p-4'>
      <div className='w-full'>

        <div className='flex justify-center   w-[130px] cursor-pointer h-[45px] px-2 py-2 bg-[#FDBC12] text-darkblue items-center rounded-lg gap-2' onClick={() => openModal('')}>
          <BsPlusCircleFill/>  <h6>Add New</h6>
   </div>

   <div>
   {sliderdata.length > 0 ? (
     <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4">
          {sliderdata.map((item) => (
            
            <div className='bg-white rounded-lg p-2 drop-shadow-md'>
              <img
      className="h-40 object-cover flex justify-center items-center w-full max-w-full rounded-lg  mb-2"
      src={
        item.image
          ? item.image.startsWith("http")
            ? item.image // Use the full URL if already valid
            : `${api}/${item.image}` // Prepend base URL for relative paths
          : "https://via.placeholder.com/150" // Placeholder image for missing URLs
      }
      alt={item.image || "Image"}
    />
              
               
               <div className='flex justify-between gap-4'> 
            
                <div className='flex  w-full justify-center cursor-pointer   py-2 border border-red-600 text-red-600 items-center rounded-lg gap-2' onClick={() => deletePost(item.id)}>
             <RiDeleteBin5Line/>  <h6>Delete Post</h6>
            </div>

            </div>
               
            </div>
          ))}
       </div>
      ) : (
        <p>Loading...</p>
      )}
   </div>
   
   </div>
      

   {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal  postId={selectedPostId} onClose={closeModal} />
          </div>
        </div>
      )}
   </div>
  )
}


interface ModalProps {
    postId?: string | null; 
    onClose: () => void;
  }
  
  const Modal: React.FC<ModalProps> = ({ postId, onClose }) => {
  
    const api = process.env.REACT_APP_API_URL as string;
    const [formData, setFormData] = useState({
      image: null as File | null,
  
    });
    const [fileName, setFileName] = useState<string | null>(null);
    const [error, setError] = useState<string>('');
  
    useEffect(() => {
      if (postId) {
        const fetchPost = async () => {
          try {
            const response = await axios.get(`${api}/auth/gallery/${postId}`);
    
  
            const data = Array.isArray(response.data) ? response.data[0] : response.data;
   // Access the first element
    
            // Destructure from the first element of the array
            const {  image: image} = data;
        
    //console.log("Image:", image);
    setFormData({
      image: image || null,
       
    });
    
            setFileName(image);
          } catch (err) {
            console.error('Error fetching post:', err);
          }
        };
        fetchPost();
      }
    }, [postId]);
  
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };
  
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0] || null;
      setFormData((prev) => ({ ...prev, image: file }));
      setFileName(file ? file.name : null);
    };
  
    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
    
      // Validate fields
  
    
    
      const data = new FormData();
      if (formData.image) {data.append('image', formData.image);}
      
      else if(fileName){
       
        data.append('image',fileName);
      }
  
  
  
      //console.log('Data data '+formData.image);
      //console.log('filename '+fileName);
    
      // //console.log('Submitting form data:', {
      //   image: formData.image,
      // });
    
      try {
          await axios.post(`${api}/auth/gallery`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          //console.log('slider created successfully');
        
        onClose();
        window.location.href  = '/dashboard';
      } catch (err) {
        console.error('Error submitting post:', err);
        setError('Failed to submit the post. Please try again.');
      }
    };
    
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white lg:w-1/2 md:[75%] w-[96%] p-6 rounded shadow relative">
          
          <form onSubmit={handleSubmit} className="space-y-4">
          
  
  
            
  
            
            {/* File Upload */}
            <div>
              <label className="text-[#030303]  font-medium">  Add media</label>
              <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
             
                <RiGalleryUploadLine size={24} className="text-[30px] cursor-pointer"
                                  onClick={() => document.getElementById('file-upload')?.click()}  />
                <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name='image'
              
                onChange={handleFileChange}
  
                
              />
              {fileName ? (
    <p className="text-[14px] text-[#02256d] mt-2">
      Selected file: <span className="font-bold">{fileName}</span>
    </p>
  ) : (
    <p className="font-bold text-[14px]">
      Drag and Drop or{' '}
      <span className="text-[#02256d]">click to upload</span>
    </p>
  )}
              </div>
              
            </div>
  
            {/* Error Message */}
            {error && <p className="text-red-500">{error}</p>}
  
  
  <div className=' flex justify-between'>
  
              {/*Cancel form button*/}
              <button className='mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold'  onClick={onClose}>Cancel</button>
               {/* Submit Button */}
            <button
              type="submit"
              className='mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold'
              disabled={!formData.image}
            >
              {postId ? 'Update Image' : 'Add Image'}
            </button>
            </div>
           
  
  
  
  
            
          </form>
        </div>
      </div>
    );
  };
export default Gallery